import { getTime, getWeekDay, hourIsAfter, isSameDay, isTheDayAfterTomorrow, isTomorrow, } from "core/utils/date";
export function getVariant(startDate, endDate) {
    var start = Date.parse(startDate);
    var end = Date.parse(endDate);
    var now = Date.now();
    var day = getWeekDay(start);
    var time = getTime(start);
    if (isTomorrow(now, start))
        return { kind: "Tomorrow", time: time };
    if (isTheDayAfterTomorrow(now, start))
        return { kind: "DayAfterTomorrow", time: time };
    if (!isSameDay(now, start) || now >= end)
        return { kind: "Other", day: day, time: time };
    if (now >= start && now <= end)
        return { kind: "Live", time: time };
    if (hourIsAfter(17, start))
        return { kind: "Tonight", time: time };
    return { kind: "Today", time: time };
}
